import React, { useEffect, useState } from 'react'
import Footer from '../../components/Footer'
import { Container, Modal } from 'react-bootstrap'
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Swal from 'sweetalert2';
import { onSnapshot, doc, collection } from "firebase/firestore";
import { db } from '../../firebase';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function MyDashboardAdmin() {
  const [leads, setLeads] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isPriceModalOpen, setIsPriceModalOpen] = useState(false);
  const [price, setPrice] = useState("");
  const apiKey = process.env.REACT_APP_API_KEY;
  const [userId, setUserId] = useState(null);

  const auth = getAuth();
  const fetchLeads = async (uid) => {
    try {
      const response = await axios.get(
        `https://api.v1.spotyourleads.com/lead?type=admin&userId=${uid}&limit=9999999&page=1`,
        {
          headers: { "x-api-key": apiKey },
        }
      );
      setLeads(Array.isArray(response?.data?.leads) ? response?.data?.leads : []);
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  };


  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);

        const unsubscribe = onSnapshot(
          collection(db, "leads"),
          (snapshot) => {

            fetchLeads(user.uid)
          },
          (error) => {
            console.error("Firestore onSnapshot error:", error);
          }
        );
        return () => unsubscribe();
      } else {
        setLeads([]);
      }
    });

    return () => unsubscribeAuth();
  }, []);


  const showSuccess = (message) => {
    Swal.fire({
      icon: "success",
      title: "Success",
      text: message,
      timer: 2000,
      showConfirmButton: false,
    });
  };

  const showError = (message) => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: message,
    });
  };

  const handleAccept = async (leadId) => {
    try {
      const response = await fetch(
        `https://api.v1.spotyourleads.com/lead/accept?leadId=${leadId}&userId=${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
      );

      const data = await response.json();

      if (response.status === 200) {
        showSuccess(data.message);
        setLeads((prevLeads) =>
          prevLeads?.map((lead) =>
            lead.id === leadId ? { ...lead, status: "accepted" } : lead
          )
        );
      } else {
        showError(data.message || "Error accepting lead");
      }
    } catch (error) {
      showError("Error accepting lead");
    }
  };


  const handleReject = async (leadId) => {
    try {
      const response = await fetch(`https://api.v1.spotyourleads.com/lead/reject?leadId=${leadId}&userId=${userId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
      });
      const data = await response?.json();

      if (response?.status === 200) {
        showSuccess(data?.message);
        setLeads((prevLeads) =>
          prevLeads?.map((lead) =>
            lead.id === leadId ? { ...lead, status: "rejected" } : lead
          )
        );
      } else {
        showError(data?.message || "Error Rejecting lead");
      }


    } catch (error) {
      showError("Error rejecting lead");
    }
  };

  const handleUpdateLead = async () => {
    try {
      const response = await fetch("https://api.v1.spotyourleads.com/lead/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify({
          ...selectedLead,
          userId: userId
        }),
      });
      const data = await response.json();

      if (response.status === 200) {
        setIsUpdateModalOpen(false);
        showSuccess(data?.message);

        setLeads((prevLeads) =>
          prevLeads?.map((lead) =>
            lead.id === selectedLead.id ? { ...lead, ...selectedLead } : lead
          )
        );
      } else {
        showError(data?.message || "Error updating lead");
      }

    } catch (error) {
      showError("Error updating lead");
    }
  };

  const handleAddPrice = async () => {
    try {
      const response = await fetch(`https://api.v1.spotyourleads.com/lead/price?leadId=${selectedLead.id}&price=${price}&userId=${userId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
      });
      const data = await response.json();

      if (response.status === 200) {
        setIsPriceModalOpen(false);
        showSuccess(data?.message || "Price added successfully!");

        setLeads((prevLeads) =>
          prevLeads?.map((lead) =>
            lead.id === selectedLead.id ? { ...lead, price } : lead
          )
        );
      } else {
        showError(data?.message || "Error adding price");
      }

    } catch (error) {
      showError("Error adding price");
    }
  };
  const openUpdateModal = (lead) => {
    setSelectedLead(lead);
    setIsUpdateModalOpen(true);
  };

  const openPriceModal = (lead) => {
    setSelectedLead(lead);
    setIsPriceModalOpen(true);
  };

  const exportLeadsToCSV = () => {
    if (!leads || leads.length === 0) {
      return Swal.fire("No data", "There are no leads to export", "info");
    }

    const headers = Object.keys(leads[0]);
    const csvRows = [
      headers.join(","),
      ...leads.map(item =>
        headers.map(field => {
          const val = item[field];
          if (Array.isArray(val)) return `"${val.join(",")}"`;
          if (typeof val === "string") return `"${val.replace(/"/g, '""')}"`;
          return val ?? "";
        }).join(",")
      )
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "admin-leads.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };
  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };


  return (
    <>
      <Helmet>
        <title>Spot Your Leads |  My Dashboard </title>
      </Helmet>
      <section className="leadsShop my-admin-dashboard">
        {leads?.length > 0 ?
          <button
            className="btn btn-success"
            onClick={exportLeadsToCSV}
          >
            Export to CSV
          </button>
          : null}
        <Container fluid>
          <div>
            <Container fluid className="mx-auto p-6">
              <div className="overflow-x-auto my-5 table-container">
              <table className="history-table table table-bordered table-striped">

                  <thead>
                    <tr className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                      <th className="py-3 px-6 text-left">ID</th>
                      <th className="py-3 px-6 text-left">Owner</th>
                      <th className="py-3 px-6 text-left">Property</th>
                      <th className="py-3 px-6 text-left">Phone</th>
                      <th className="py-3 px-6 text-left">Actions</th>

                      <th className="py-3 px-6 text-left">Status</th>
                      <th className="py-3 px-6 text-left">Lead Status</th>

                      <th className="py-3 px-6 text-left">Buyer ID</th>
                      <th className="py-3 px-6 text-left">Closing Time</th>
                      <th className="py-3 px-6 text-left">Created At</th>
                      <th className="py-3 px-6 text-left">updated At</th>
                      <th className="py-3 px-6 text-left">purchased At</th>
                      <th className="py-3 px-6 text-left">accepted At</th>
                      <th className="py-3 px-6 text-left">rejected At</th>
                      <th className="py-3 px-6 text-left">Discount Percentage</th>
                      <th className="py-3 px-6 text-left">hasMortgage</th>
                      <th className="py-3 px-6 text-left">Owned Years</th>
                      <th className="py-3 px-6 text-left">Property Listed</th>
                      <th className="py-3 px-6 text-left">Reason for Selling</th>
                      <th className="py-3 px-6 text-left">Repairs Needed</th>
                      <th className="py-3 px-6 text-left">State</th>
                      <th className="py-3 px-6 text-left">City</th>

                      <th className="py-3 px-6 text-left">Lead Template</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700 text-sm">
                    {leads?.map((lead) => (
                      <tr key={lead.id} className="border-b hover:bg-gray-100">
                        <td className="py-3 px-6">{lead.id}</td>
                        <td className="py-3 px-6">{lead.ownerFirstName} {lead.ownerLastName}</td>
                        <td className="py-3 px-6">{lead.propertyAddress}</td>
                        <td className="py-3 px-6">{lead.phoneNumber}</td>

                        <td className="py-3 px-6 space-x-2">
                          <div className=' button-dash'>

                            <button onClick={() => handleAccept(lead.id)} className="accept px-3 py-1 rounded-md text-xs">
                              Accept
                            </button>

                            <button onClick={() => handleReject(lead.id)} className="reject px-3 py-1 rounded-md text-xs">
                              Reject
                            </button></div>
                          <div className=' button-dash'>

                            <button onClick={() => openUpdateModal(lead)} className="update px-3 py-1 rounded-md text-xs">
                              Update
                            </button>
                            <button onClick={() => openPriceModal(lead)} className="add-price px-3 py-1 rounded-md text-xs">
                              Add Price
                            </button>


                          </div>
                        </td>
                        <td className="py-3 px-6">
                          <span
                            className={`px-3 py-1 rounded-full text-white text-xs ${lead.status === "accepted" ? "accepted" :
                              lead.status === "pending" ? "pending" :
                                lead.status === "rejected" ? "rejected" :
                                  lead.status === "discounted" ? "discounted" :
                                    lead.status === "purchased" ? "purchased" : null
                              }`}
                          >
                            {lead.status}
                          </span>
                        </td>
                        <td className="py-3 px-6">

                          {lead.dashboardStatus || '-'}
                        </td>

                        <td className="py-3 px-6">{lead.buyerId || '-'}</td>
                        <td className="py-3 px-6">{lead.closingTime}</td>
                        <td className="py-3 px-6">{new Date(lead.createdAt * 1000).toLocaleDateString()}</td>
                        <td className="py-3 px-6">{lead.updatedAt ? new Date(lead.updatedAt * 1000).toLocaleDateString() : '-'}</td>
                        <td className="py-3 px-6">{lead.purchasedAt ? new Date(lead.purchasedAt * 1000).toLocaleDateString() : '-'}</td>
                        <td className="py-3 px-6">{lead.acceptedAt ? new Date(lead.acceptedAt * 1000).toLocaleDateString() : '-'}</td>
                        <td className="py-3 px-6">{lead.rejectedAt ? new Date(lead.rejectedAt * 1000).toLocaleDateString() : '-'}</td>

                        <td className="py-3 px-6">{lead.discountPercentage}%</td>
                        <td className="py-3 px-6">{lead.hasMortgage}</td>
                        <td className="py-3 px-6">{lead.ownedYears}</td>
                        <td className="py-3 px-6">{lead.propertyListed}</td>
                        <td className="py-3 px-6">{lead.sellingReason}</td>
                        <td className="py-3 px-6">{lead.repairsNeeded}</td>
                        <td className="py-3 px-6">{lead.state}</td>
                        <td className="py-3 px-6">{lead.city}</td>

                        <td className="py-3 px-6">
                        <div dangerouslySetInnerHTML={{ __html: lead.leadTemplate }} />


                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>

                {isUpdateModalOpen && (
                  <Modal className='modal-add-price modal-update-lead' show={isUpdateModalOpen} onHide={() => setIsUpdateModalOpen(false)}>
                    <Modal.Header closeButton>
                      <Modal.Title><h3>Update Lead</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <form className="space-y-2">
                        <h5>Is your property listed with a real estate agent?</h5>
                        <label>
                          <input
                            type="radio"
                            name="propertyListed"
                            value="No it's not listed"
                            checked={selectedLead.propertyListed === "No it's not listed"}
                            onChange={(e) => setSelectedLead({ ...selectedLead, propertyListed: e.target.value })}
                          />
                          <span>No it's not listed</span>
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            name="propertyListed"
                            value="Yes it's listed"
                            checked={selectedLead.propertyListed === "Yes it's listed"}
                            onChange={(e) => setSelectedLead({ ...selectedLead, propertyListed: e.target.value })}
                          />
                          <span>Yes it's listed</span>
                        </label>

                        {/* <input type="text" placeholder="Property Listed" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.propertyListed} onChange={(e) => setSelectedLead({ ...selectedLead, propertyListed: e.target.value })} /> */}
                        {/* <input type="text" placeholder="Property Owner" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.propertyOwner} onChange={(e) => setSelectedLead({ ...selectedLead, propertyOwner: e.target.value })} /> */}
                        <h5>Are you the owner of this property?</h5>
                        <label>
                          <input
                            type="radio"
                            name="propertyOwner"
                            value="Yes, i own this property"
                            checked={selectedLead.propertyOwner == "Yes, i own this property"}
                            onChange={(e) => setSelectedLead({ ...selectedLead, propertyOwner: e.target.value })}
                          />
                          <span>
                            Yes, I own this property
                          </span>
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            name="propertyOwner"
                            value="Agent/wholesaler/Property Manager"
                            checked={selectedLead.propertyOwner == "Agent/wholesaler/Property Manager"}
                            onChange={(e) => setSelectedLead({ ...selectedLead, propertyOwner: e.target.value })}
                          />
                          <span>
                            Agent/Wholesaler/Property Manager
                          </span>
                        </label>
                        <h5>Owned Years</h5>

                        <input type="text" placeholder="Owned Years" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.ownedYears} onChange={(e) => setSelectedLead({ ...selectedLead, ownedYears: e.target.value })} />
                        <h5>Is there a Mortgage on the house?</h5>
                        <label>
                          <input
                            type="radio"
                            name="hasMortgage"
                            value="Yes"
                            checked={selectedLead.hasMortgage === "Yes"}
                            onChange={(e) => setSelectedLead({ ...selectedLead, hasMortgage: e.target.value })}
                          />
                          <span>Yes</span>
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            name="hasMortgage"
                            value="There is no hasMortgage"
                            checked={selectedLead.hasMortgage === "There is no hasMortgage"}
                            onChange={(e) => setSelectedLead({ ...selectedLead, hasMortgage: e.target.value })}
                          />
                          <span>There is no Mortgage</span>
                        </label>

                        {/* <input type="text" placeholder="hasMortgage" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.hasMortgage} onChange={(e) => setSelectedLead({ ...selectedLead, hasMortgage: e.target.value })} /> */}
                        {/* <input type="text" placeholder="propertyOwner" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.propertyOwner} onChange={(e) => setSelectedLead({ ...selectedLead, propertyOwner: e.target.value })} /> */}

                        <h5>Type of the Property</h5>
                        <select
                          name="propertyType"
                          className="form-control"
                          value={selectedLead.propertyType}
                          onChange={(e) => setSelectedLead({ ...selectedLead, propertyType: e.target.value })}
                        >
                          <option value="">Select a property type</option>
                          <option value="Single family">Single family</option>
                          <option value="Ranch">Ranch</option>
                          <option value="2-story">2-story</option>
                          <option value="Mobile home owned land">Mobile home owned land</option>
                          <option value="Mobile home rented land">Mobile home rented land</option>
                          <option value="Multifamily">Multifamily</option>
                          <option value="Bungalow">Bungalow</option>
                          <option value="Cottage">Cottage</option>
                          <option value="Townhouse">Townhouse</option>


                          <option value="Condominium">Condominium</option>
                          <option value="Duplex">Duplex</option>
                          <option value="Farmhouse">Farmhouse</option>
                          <option value="Split-level home">Split-level home</option>
                          <option value="Land">Land</option>
                          <option value="Commercial Property">Commercial Property</option>
                        </select>

                        {/* <input type="text" placeholder="Property Type" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.propertyType} onChange={(e) => setSelectedLead({ ...selectedLead, propertyType: e.target.value })} /> */}
                        <h5>What kind of repairs does the property need?</h5>

                        {[
                          "It's a brand new home and needs nothing",
                          "Structural Problems",
                          "Flood/storm/fire damage",
                          "Roof Needs Replacement",
                          "Foundation Problems",
                          "Bathroom(s) need work",
                          "Paint Inside",
                          "Boiler/Water Heater",
                          "Landscaping",
                          "Electrical",
                          "Plumbing",
                          "Flooring",
                          "Kitchen Cabinets",
                          "Kitchen Appliances",
                          "Paint Outside",
                          "Air Conditioning",
                          "Windows",
                          "Walls",
                          "Needs a total rehab",
                        ].map((repair) => (
                          <div key={repair} className="flex items-center mb-2">
                            <label className="flex items-center">
                              <input
                                type="radio"
                                name="repairsNeeded"
                                value={repair}
                                checked={selectedLead.repairsNeeded === repair}
                                onChange={(e) => setSelectedLead({ ...selectedLead, repairsNeeded: e.target.value })}
                                className="mr-2"
                              />
                              <span>{repair}</span>
                            </label>
                          </div>
                        ))}

                        {/* <input type="text" placeholder="Repairs Needed" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.repairsNeeded} onChange={(e) => setSelectedLead({ ...selectedLead, repairsNeeded: e.target.value })} /> */}
                        {/* <input type="text" placeholder="Reason for Selling" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.sellingReason} onChange={(e) => setSelectedLead({ ...selectedLead, sellingReason: e.target.value })} /> */}
                        <h5>What would be the reason for selling?</h5>

                        {[
                          "Preforeclosure",
                          "Emergency Reasons",
                          "Financial Reasons",
                          "Selling a vacant/non-occupied house",
                          "Sell and invest in something else",
                          "Death in the family",
                          "Inherited Property",
                          "Downsizing",
                          "Upsize",
                          "Tired of being a landlord",
                          "Moving closer to family",
                          "Retirement elsewhere",
                          "Moving from United States",
                          "Moving to another state",
                          "Extra property doesn't need it",
                        ].map((reason) => (
                          <div key={reason} className="flex items-center mb-2">
                            <label className="flex items-center">
                              <input
                                type="radio"
                                name="sellingReason"
                                value={reason}
                                checked={selectedLead.sellingReason === reason}
                                onChange={(e) => setSelectedLead({ ...selectedLead, sellingReason: e.target.value })}
                                className="mr-2"
                              />
                              <span>{reason}</span>
                            </label>
                          </div>
                        ))}
                        <h5>How soon are you looking to close?</h5>

                        <select
                          name="closingTime"
                          className="w-full p-2 border rounded-md form-control my-1"
                          value={selectedLead.closingTime}
                          onChange={(e) => setSelectedLead({ ...selectedLead, closingTime: e.target.value })}
                        >
                          <option value="">Select a closing time</option>
                          <option value="ASAP">ASAP</option>
                          <option value="Couple weeks">Couple weeks</option>
                          <option value="1 Month">1 Month</option>
                          <option value="2 Months">2 Months</option>
                          <option value="3 Months">3 Months</option>
                          <option value="4~5 Months">4~5 Months</option>
                          <option value="6 Months">6 Months</option>
                        </select>
                        <h5>Owner First Name</h5>

                        {/* <input type="text" placeholder="Closing Time" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.closingTime} onChange={(e) => setSelectedLead({ ...selectedLead, closingTime: e.target.value })} /> */}
                        <input type="text" placeholder="Owner First Name" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.ownerFirstName} onChange={(e) => setSelectedLead({ ...selectedLead, ownerFirstName: e.target.value })} />
                        <h5>Owner Last Name</h5>

                        <input type="text" placeholder="Owner Last Name" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.ownerLastName} onChange={(e) => setSelectedLead({ ...selectedLead, ownerLastName: e.target.value })} />
                        <h5>Property Address</h5>

                        <input type="text" placeholder="Property Address" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.propertyAddress} onChange={(e) => setSelectedLead({ ...selectedLead, propertyAddress: e.target.value })} />
                        <h5>Phone Number</h5>

                        <input type="text" placeholder="Phone Number" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.phoneNumber} onChange={(e) => setSelectedLead({ ...selectedLead, phoneNumber: e.target.value })} />
                        <h5>Lead Template</h5>
                        <ReactQuill
  theme="snow"
  value={selectedLead.leadTemplate}
  onChange={(content) => setSelectedLead({ ...selectedLead, leadTemplate: content })}
/>


{/* <div className="mt-4 p-2 border rounded">
  {stripHtmlTags(selectedLead.leadTemplate)}
</div> */}

                        {/* <input type="text" placeholder="Lead Template" className="w-full p-2 border rounded-md form-control my-1" value={selectedLead.leadTemplate} onChange={(e) => setSelectedLead({ ...selectedLead, leadTemplate: e.target.value })} /> */}
                      </form>
                    </Modal.Body>
                    <Modal.Footer>
                      <button onClick={() => setIsUpdateModalOpen(false)} className="accept px-4 py-2 bg-gray-500 text-white rounded-md">
                        Cancel
                      </button>
                      <button onClick={handleUpdateLead} className="cancel px-4 py-2 bg-blue-500 text-white rounded-md">
                        Save
                      </button>
                    </Modal.Footer>
                  </Modal>
                )}
                {isPriceModalOpen && (
                  <Modal show={isPriceModalOpen} onClose={() => setIsUpdateModalOpen(false)} title="Update Lead">

                    <div className="fixed modal-add-price inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center">
                      <div className="bg-white px-5 py-5 p-6 rounded-lg shadow-lg w-1/3">
                        <h3 className="text-xl font-bold mb-4">Add Price</h3>
                        <input
                          type="number"
                          className="w-full p-2 border rounded-md form-control"
                          placeholder="Enter Price"
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                        />
                        <div className="flex d-flex justify-end space-x-2 mt-4">

                          <button onClick={handleAddPrice} className="accept px-4 py-2 bg-yellow-500 text-white rounded-md">
                            Submit
                          </button>
                          <button onClick={() => setIsPriceModalOpen(false)} className="cancel px-4 py-2 bg-gray-500 text-white rounded-md">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Modal>
                )}
              </div>
            </Container>

          </div>
        </Container>
      </section>
      <Footer />
    </>
  )
}

export default MyDashboardAdmin
